// PageLoader.jsx
import React from "react";
import { Backdrop, CircularProgress, Box } from "@mui/material";

const PageLoader = ({ open, text }) => {
  return (
    <Backdrop
      sx={{
        color: "#fff",
        zIndex: 1700,
        backgroundColor: "rgba(0, 0, 0, 0.5)", // Semi-transparent dark background
      }}
      open={open}
    >
      <Box display="flex" flexDirection="column" alignItems="center">
        <CircularProgress color="inherit" />
        <Box mt={2}>{text?`${text}...`:`Loading...`}</Box>
      </Box>
    </Backdrop>
  );
};

export default PageLoader;
